
const ProgressBar = ({ count = 0 }: { count: number }) => {
    return (
        <div className='w-full flex justify-center px-4'>
            <div className={`mb-8 bg-primary h-3 rounded-md`}
                style={{ width: `${count}%` }}
            >
            </div>
        </div>
    )
}

export default ProgressBar